import { useSelector } from 'react-redux'

import { selfpayStatusOptionsPayerTypes } from '../../../../lib/systemData'
import DefaultUpdater from '../../../common/DefaultUpdater'
import PayerTypeStatusGlobalModal from '../../../common/modal/PayerTypeStatusGlobalModal'
import classes from './SelfPayControls.module.css'

export default function SelfPayControls() {
    const activeCase = useSelector(state => state.case.activeCase) 
    return <div className={classes.container}>
        <PayerTypeStatusGlobalModal date={activeCase?.selfpay?.payer_status_date} user={activeCase?.selfpay?.payer_status_by}>                        
            <DefaultUpdater type={'select'} value={activeCase?.selfpay?.payer_status_id} options={selfpayStatusOptionsPayerTypes()} label={'Self Pay Status'} identifier={{type: 'case_selfpay', field: 'payer_status_id', type_id: null, folder: 'selfpay'}} extraOptions={{hasRemove: true}}/>
        </PayerTypeStatusGlobalModal>  
    </div>
}